import { type MapSettingsDataServerModel } from '~/map/map.repository';
import { mapSettingsBoundariesSerializer } from '~/store/mapSettings/boundaries/mapSettingsBoundaries.serializer';
import { type AppState } from '../../app.store';
import { mapSettingsDrawingSerializer } from '../drawing/mapSettingsDrawing.serializer';
import { fileAttachmentSerializer } from '../fileAttachments/fileAttachments.serializer';
import { mapSettingsHeatmapSerializer } from '../heatmaps/mapSettingsHeatmaps.serializer';
import { mapSettingsMarkersSerializer } from '../markers/mapSettingsMarkers.serializer';
import { mapSettingsProximitySerializer } from '../proximity/mapSettingsProximity.serializer';
import { mapSettingsPublicMapSettingsSerializer } from '../publicMapSettings/mapSettingsPublicMapSettings.serializer';
import { mapSettingsSearchSerializer } from '../search/mapSettingsSearch.serializer';
import { mapSettingsToolsStateSerializer } from '../toolsState/mapSettingsToolsState.serializer';
import { mapSettingsDataLayersSerializer } from './dataLayers/mapSettingsDataLayers.serializer';

export const mapSettingsDataSelector = (state: AppState) => state.map.mapSettings.data;

export const mapSettingsDataServerModelSelector = (state: AppState): MapSettingsDataServerModel => {
  const {
    boundaries,
    markers,
    fileAttachments,
    drawing,
    proximity,
    heatmaps,
    toolsState,
    publicMapSettings,
    dataLayers,
    search,
    ...rest
  } = mapSettingsDataSelector(state);

  return {
    ...rest,
    boundaries: mapSettingsBoundariesSerializer.stateToJson(boundaries),
    markers: mapSettingsMarkersSerializer.stateToJson(markers),
    fileAttachments: fileAttachmentSerializer.stateToJson(fileAttachments),
    drawing: mapSettingsDrawingSerializer.stateToJson(drawing),
    proximity: mapSettingsProximitySerializer.stateToJson(proximity),
    heatmaps: mapSettingsHeatmapSerializer.stateToJson(heatmaps),
    toolsState: mapSettingsToolsStateSerializer.stateToJson(toolsState),
    publicMapSettings: mapSettingsPublicMapSettingsSerializer.stateToJson(publicMapSettings),
    dataLayers: mapSettingsDataLayersSerializer.stateToJson(dataLayers),
    search: mapSettingsSearchSerializer.stateToJson(search),
  };
};
